export const projectData = [
  {
    name: "Spotifye",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141733/webp-portfolio-projs/cvybn0inebl6tm1uhjq2_vmzyuc.webp",
    desc: `A complex web app built using a mix-match of Spotify, Youtube Music & Deezer's Ui's & Api's.`,
    link: "https://spotify-e.netlify.app",
  },

  {
    name: "iNotes Clone",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141732/webp-portfolio-projs/ehj7oxn3c6khmm2jgv0h_lsatpu.webp",
    desc: `This PWA is a complete fullstack clone of the Apple Notes app,
     i built publicly using the MERN stack.`,
    link: "https://inotes-mini.netlify.app/",
  },

  {
    name: "Insttagg",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141734/webp-portfolio-projs/hzekob0otdjdi5k3eqeh_psqa91.webp",
    desc: `A complete Fullstack re-design of 
    Instagram, complete with auth, like, share, bookmark, view, crud, 
    routing e.t.c functionalities. `,
    link: "https://insttagg-client.vercel.app",
  },

  {
    name: "WhatsApp Clone",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141734/webp-portfolio-projs/jibpcuv7lrymerkwr1or_shoogm.webp",
    desc: `I built a chat app based off WhatsApp using the most
    creative & effecient solutions i could provide. It performs Realtime Chat, CRUD operations, e.t.c`,
    link: "https://whatsapp-mini.netlify.app",
  },

  {
    name: "Booksy",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141737/webp-portfolio-projs/tvf875wgowwczaiyy4zc_jtfqsa.webp",
    desc: `I Built Booksy as a special personal side-project, 
    this site contains fullstack / crud / authentication 
    functionalities using a BAAS(Firebase).`,
    link: "https://booksyy.netlify.app",
  },

  {
    name: "Typrr",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141732/webp-portfolio-projs/eunjdrs03vky8b8g5hxk_cyluyj.webp",
    desc: `Typrr is a classic typing test game built with ReactJs & TypeScript.
     I added a leaderboard feature, so feel free to compete with your friends online.`,
    link: "https://typrr.netlify.app/",
  },

  {
    name: "Faaji",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704186379/webp-portfolio-projs/Screenshot_2024-01-02_at_9.47.49_AM_wq3dud.webp",
    desc: "I work as a Frontend Developer at Faaji, a tech startup based in Lagos, Nigeria.",
    link: "https://faaji.app/",
  },

  {
    name: "Translynx Marine",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1723160773/Screenshot_2024-08-09_at_12.44.48_AM_z4e1p5.png",
    desc: "A landing/showcase page for Jeanneau & Mercury boats & engines available through Translynx Marine.",
    link: "https://translynxmarine.com/",
  },

  {
    name: "Unilo",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704186378/webp-portfolio-projs/Screenshot_2024-01-02_at_9.54.30_AM_al5efr.webp",
    desc: "A landing page for a delivery service startup based in Lagos, Nigeria.",
    link: "https://unilo.africa/",
  },

  {
    name: "Service Guys",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704186379/webp-portfolio-projs/Screenshot_2024-01-02_at_9.56.06_AM_vdirom.webp",
    desc: "A landing page for an on-demand workforce partner in Auckland, New Zealand.",
    link: "https://www.serviceguys.co.nz/",
  },

  {
    name: "Burger-A",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141736/webp-portfolio-projs/sdku25xhbat8wkc6p7id_mpxubd.webp",
    desc: "A web app that allows users to build their custom Burger & mimic Checkout.",
    link: "https://burger-a.netlify.app/make-burger",
  },

  {
    name: "Rock Paper Scissors",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141731/webp-portfolio-projs/bxiczwgnpywlxa4alsda_rkzud1.webp",
    desc: "I completed Frontend Mentors' R-P-S game challenge (plus the bonus roundd) using Reactjs.",
    link: "https://rok-paper-sci.netlify.app",
  },

  {
    name: "Weather App",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141733/webp-portfolio-projs/esz1tumkj5z0vsmc6y0g_hgvkjg.webp",
    desc: "Created my First Weather App!!(With ReactJs)Everybody should have at least one weather app imho.",
    link: "https://what-is-the-weather-proj.netlify.app/",
  },

  {
    name: "Whac-A-Mole",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141734/webp-portfolio-projs/Screenshot_2023-12-12_at_1.07.59_AM_bd4c40_xwpjvu.webp",
    desc: "A fun Whac-A-Mole game I built using Vue & TypeScript.",
    link: "https://whark-a-mole.netlify.app/",
  },

  {
    name: "Where-In-The-World",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141735/webp-portfolio-projs/ssby7dcwksfumti1zidq_hejhph.webp",
    desc: "A frontendmentor.io challenge I completed In a 24hour sprint.",
    link: "https://where-in-the-worldd.netlify.app",
  },
  {
    name: "Tiny Moviez",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141734/webp-portfolio-projs/kdyljfbj0wfffgrodkcp_mv0wgo.webp",
    desc: "I Built an API powered Movie search app using The Movie database.",
    link: "https://tiny-movies-temidayo.netlify.app/",
  },

  {
    name: "Manage Landing Page",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141672/webp-portfolio-projs/atuars3pg17vzshez6yk_obafam.webp",
    desc: "Manage makes it simple for software teams to plan day-to-day tasks while keeping the larger team goals in view.",
    link: "https://manage-page-temidayo.netlify.app",
  },

  {
    name: "Panda Nft",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141738/webp-portfolio-projs/vjibhs6hm8majcotobaa_ig3zyf.webp",
    desc: "I built a NFT landing page using mainly inbuilt css flexbox-properties for Responsiveness.",
    link: "https://panda-nfts.netlify.app/",
  },

  {
    name: "SaturnFi(Demo)",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141734/webp-portfolio-projs/gwkfclmo20qonuutkrlr_h4cdol.webp",
    desc: "A freelance project on a contract for a Blockchain startup.",
    link: "https://saturn-fi-temidayo.netlify.app/",
  },

  {
    name: "Bithub",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141737/webp-portfolio-projs/xsougox9vm3qxniytuaf_ztfyn7.webp",
    desc: "I built Github, but as Bithub using Github's official REST Api/localStorage to retrive users info.",
    link: "https://bit-hub.netlify.app/",
  },

  {
    name: "AfroJazz Fest",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704186380/webp-portfolio-projs/Screenshot_2024-01-02_at_9.58.18_AM_xc0wla.webp",
    desc: "A tiny landing page i built for a Jazz festival.",
    link: "https://afrojazzfest.org/",
  },

  {
    name: "Reports Dashboard",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704188818/webp-portfolio-projs/WhatsApp_Image_2024-01-02_at_10.45.54_AM_ddqhlr.jpg",
    desc: "A freelance data dashboard i built for a client with multiple, complex functionalities.",
    link: "/projects",
  },

  {
    name: "My Portfolio",
    img: "https://res.cloudinary.com/temidayo-falomo/image/upload/v1704141733/webp-portfolio-projs/fru0wcc1pqzxqshbnj5g_iisohl.webp",
    desc: `For this.Portfolio website, 
    I used Vanilla CSS all-through so
     i could easily have maximum control over my layouts.`,
    link: "https://temidayo-falomo.netlify.app/",
  },
];

export const projectList = [
  {
    name: "Tiny Moviez",
    link: "https://github.com/temidayo-falomo/Movies-Api-Project",
  },
  {
    name: "Manage Page",
    link: "",
  },
  {
    name: "Nft Page",
  },
  {
    name: "Fast Fly",
  },
  {
    name: "Weather App",
  },
  {
    name: "Shopping Cart",
  },
  {
    name: "Advice Gen Api",
  },
  {
    name: "Burger A",
  },
  {
    name: "Bithub",
  },
  {
    name: "Typrr",
  },
  {
    name: "Booksy",
  },
  {
    name: "Coin Fi",
  },
  {
    name: "Panda NFTs",
  },
  {
    name: "Rock Paper Scissors",
  },
  {
    name: "Saturn Fi",
  },
  {
    name: "Where In The World",
  },
  {
    name: "Insttagg",
  },
  {
    name: "WhatsApp Clone",
  },
  {
    name: "iNotes Clone",
  },
  {
    name: "My Portfolio",
  },
  {
    name: "Spotifye",
  },
  {
    name: "Whac-A-Mole",
  },
];
